(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/square-button/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/square-button/assets/javascripts/render-component.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const isServer = typeof exports === 'object';

async function renderComponent(model, widgetInfo, position) {
  let hbsCompiled;

  if (isServer) {
    const hbs = global.internalInstances.get('hbs');
    hbsCompiled = hbs.cache['components-banner_layouts-square_button-square_button'];
  } else {
    hbsCompiled = svs.banner_layouts.square_button.templates.square_button;
  }

  return hbsCompiled(_objectSpread(_objectSpread({}, model.layoutConfig), {}, {
    callToActions: model.callToActions,
    bannerId: model.id,
    clickTrackingString: "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.widgetName, "/").concat(position, "/").concat(model.layoutType, "/").concat(model.title),
    impressionTrackingString: "".concat(widgetInfo.widgetType, "/").concat(widgetInfo.widgetName, "/").concat(position, "/").concat(model.layoutType, "/").concat(model.title)
  })) || '';
}

if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_layouts.square_button = {
    renderComponent
  };
}
 })(window);